import jQuery from "jquery";
import { tns } from "tiny-slider/src/tiny-slider.js";
window.$ = window.jQuery = jQuery;

let cards = $(".products-carousel");
if (cards.length > 0) {
    let slider = tns({
        container: ".products-carousel",
        items: 1,
        gutter: 20,
        slideBy: 1,
        controls: true,
        nav: false,
        loop: true,
        mouseDrag: true,
        autoplay: false,
    });
}
